import Vue from 'vue';
import gql from "fake-tag";
import { FireI18n } from 'fire-js-i18n';
import { MarkerClusterer } from "../frontend/js/markerclusterer.js";
import { LoadingElement, ImageElement, urlHelperMixin } from 'fire-vue-core';
import UmbrellaModelsSelection from "./UmbrellaModelsSelection.vue";
import VueForm from '../../../../../vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/Form.vue';

function initDealerfinder() {

    const MapStatesEnum = Object.freeze({
        OVERVIEW: "overview",
        RESULT: "result",
        DETAIL: "detail",
        ROUTE: "route",
    });

    const MobileMapStatesEnum = Object.freeze({
        SEARCH: "search",
        LIST: "list",
        MAP: "map",
    });

    if (document.querySelector('.dealerfinder')) {
        Vue.directive('clickoutside', {
            inserted: (el, binding, vnode) => {
                // assign event to the element
                el.clickOutsideEvent = function(event) {
                    // here we check if the click event is outside the element and it's children
                    if (!(el == event.target || el.contains(event.target))) {
                        // if clicked outside, call the provided method
                        vnode.context[binding.expression](event)
                    }
                }
                // register click and touch events
                document.body.addEventListener('click', el.clickOutsideEvent)
                // document.body.addEventListener('touchstart', el.clickOutsideEvent)
            },
            unbind(el) {
                // unregister click and touch events before the element is unmounted
                document.body.removeEventListener('click', el.clickOutsideEvent)
                // document.body.removeEventListener('touchstart', el.clickOutsideEvent)
            },
            stopProp(event) {
                event.stopPropagation()
            },
        });


        new Vue({
            name: 'Dealerfinder',
            el: '.dealerfinder',
            components: {
                LoadingElement,
                ImageElement,
                UmbrellaModelsSelection,
                VueForm
            },
            data: {
                isMobile: false,
                isSmartphone: false,
                element: null,
                isReady: false,
                isLoading: true,
                isLocated: false,//this is false as long as the location from the user is not set, because we want to show all results as long as the user didn't search
                scrolling: false,
                dealers: [],
                filteredDealers: [],
                dealer: null,
                countries: [],
                activeDealersMap: [],
                activeDealersList: [],
                distanceList: {},
                userCountry: null,
                addressInput: '',
                directionAddressInput: '',
                directionAddressInputEdit: false,
                /**
                 * @type {google.maps.Map}
                 */
                map: null,
                mapStyle: [
                    { "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] },
                    { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
                    { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
                    { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels",
                        "stylers": [{ "visibility": "off" }]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#bdbdbd" }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#eeeeee" }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text",
                        "stylers": [{ "visibility": "off" }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#757575" }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#e5e5e5" }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#9e9e9e" }]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#ffffff" }]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#757575" }]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#dadada" }]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#616161" }]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels",
                        "stylers": [{ "visibility": "off" }]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#9e9e9e" }]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#e5e5e5" }]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#eeeeee" }]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [{ "color": "#c9c9c9" }]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [{ "color": "#9e9e9e" }]
                    }
                ],
                icons: {
                    cluster: {
                        url: '/assets/dealerfinder/images/cluster.svg',
                        height: 60,
                        width: 60,
                        textColor: '#ffffff',
                        textSize: 14
                    },
                    clusterMobile: {
                        url: '/assets/dealerfinder/images/cluster.svg',
                        height: 45,
                        width: 45,
                        textColor: '#ffffff',
                        textSize: 12
                    },

                    // X: store (Standard/Fachhändler)
                    // P: Premium Dealer
                    // SHG: Specialist Hotel Gastronomy
                    // PHG: Premium Hotel Gastronomy
                    // RS: Repair Service
                    // V: Vita
                    store: {
                        icon: "/assets/dealerfinder/images/X.svg",
                    },
                    P: {
                        icon: "/assets/dealerfinder/images/P.svg",
                    },
                    SHG: {
                        icon: "/assets/dealerfinder/images/SHG.svg",
                    },
                    PHG: {
                        icon: "/assets/dealerfinder/images/PHG.svg",
                    },
                    RS: {
                        icon: "/assets/dealerfinder/images/RS.svg",
                    },
                    RS_SHG: {
                        icon: "/assets/dealerfinder/images/RS_SHG.svg",
                    },
                    P_SHG: {
                        icon: "/assets/dealerfinder/images/P_SHG.svg",
                    },
                    PHG_P: {
                        icon: "/assets/dealerfinder/images/PHG_P.svg",
                    },
                    PHG_RS: {
                        icon: "/assets/dealerfinder/images/PHG_RS.svg",
                    },
                    P_RS: {
                        icon: "/assets/dealerfinder/images/P_RS.svg",
                    },
                    X_RS_SHG: {
                        icon: "/assets/dealerfinder/images/X_RS_SHG.svg",
                    },
                    P_RS_SHG: {
                        icon: "/assets/dealerfinder/images/P_RS_SHG.svg",
                    },
                    X_PHG_RS: {
                        icon: "/assets/dealerfinder/images/X_PHG_RS.svg",
                    },
                    PHG_P_RS: {
                        icon: "/assets/dealerfinder/images/PHG_P_RS.svg",
                    },
                    X_PHG: {
                        icon: "/assets/dealerfinder/images/X_PHG.svg",
                    },
                    X_RS: {
                        icon: "/assets/dealerfinder/images/X_RS.svg",
                    },
                    X_SHG: {
                        icon: "/assets/dealerfinder/images/X_SHG.svg",
                    },
                    V: {
                        icon: "/assets/dealerfinder/images/V.svg",
                    },
                    V_P: {
                        icon: "/assets/dealerfinder/images/V_P.svg",
                    },
                    V_P_PHG: {
                        icon: "/assets/dealerfinder/images/V_P_PHG.svg",
                    },
                    V_PHG: {
                        icon: "/assets/dealerfinder/images/V_PHG.svg",
                    },
                    V_RS: {
                        icon: "/assets/dealerfinder/images/V_RS.svg",
                    },
                    V_RS_P: {
                        icon: "/assets/dealerfinder/images/V_RS_P.svg",
                    },
                    V_RS_P_PHG: {
                        icon: "/assets/dealerfinder/images/V_RS_P_PHG.svg",
                    },
                    V_RS_PHG: {
                        icon: "/assets/dealerfinder/images/V_RS_PHG.svg",
                    },
                    V_SHG: {
                        icon: "/assets/dealerfinder/images/V_SHG.svg",
                    },
                    V_SHG_P: {
                        icon: "/assets/dealerfinder/images/V_SHG_P.svg",
                    },
                    V_SHG_P_PHG: {
                        icon: "/assets/dealerfinder/images/V_SHG_P_PHG.svg",
                    },
                    V_SHG_PHG: {
                        icon: "/assets/dealerfinder/images/V_SHG_PHG.svg",
                    },
                    V_SHG_RS: {
                        icon: "/assets/dealerfinder/images/V_SHG_RS.svg",
                    },
                    V_SHG_RS_P: {
                        icon: "/assets/dealerfinder/images/V_SHG_RS_P.svg",
                    },
                    V_SHG_RS_P_PHG: {
                        icon: "/assets/dealerfinder/images/V_SHG_RS_P_PHG.svg",
                    },
                    V_SHG_RS_PHG: {
                        icon: "/assets/dealerfinder/images/V_SHG_RS_PHG.svg",
                    },
                    V_X:{
                        icon: "/assets/dealerfinder/images/V_X.svg",
                    },
                    V_X_P:{
                        icon: "/assets/dealerfinder/images/V_X_P.svg",
                    },
                    V_X_P_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_P_PHG.svg",
                    },
                    V_X_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_PHG.svg",
                    },
                    V_X_RS:{
                        icon: "/assets/dealerfinder/images/V_X_RS.svg",
                    },
                    V_X_RS_P:{
                        icon: "/assets/dealerfinder/images/V_X_RS_P.svg",
                    },
                    V_X_RS_P_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_RS_P_PHG.svg",
                    },
                    V_X_RS_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_RS_PHG.svg",
                    },
                    V_X_SHG:{
                        icon: "/assets/dealerfinder/images/V_X_SHG.svg",
                    },
                    V_X_SHG_P:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_P.svg",
                    },
                    V_X_SHG_P_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_P_PHG.svg",
                    },
                    V_X_SHG_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_PHG.svg",
                    },
                    V_X_SHG_RS:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_RS.svg",
                    },
                    V_X_SHG_RS_P:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_RS_P.svg",
                    },
                    V_X_SHG_RS_P_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_RS_P_PHG.svg",
                    },
                    V_X_SHG_RS_PHG:{
                        icon: "/assets/dealerfinder/images/V_X_SHG_RS_PHG.svg",
                    },

                    start: {
                        icon: "/assets/dealerfinder/images/route-pin-start.png",
                        width: 40,
                        height: 40,
                    },
                    end: {
                        icon: "/assets/dealerfinder/images/route-pin-end.png",
                        width: 40,
                        height: 40,
                    },
                },
                /**
                 * @type {google.maps.Marker[]}
                 */
                markers: [],
                markerCluster: null,
                markerStart: null,
                markerEnd: null,
                mapState: MapStatesEnum.OVERVIEW,
                mapStates: MapStatesEnum,
                searchBoundaryInKm: 30,
                kmInMeter: 1000,
                updateTimeout: null,
                defaultLocation: {
                    lng: 8.54122,
                    lat: 47.39592,
                    zoom: 12,
                },
                userLocation: null,
                slider: null,
                mobileView: MobileMapStatesEnum.SEARCH,
                mobileViews: MobileMapStatesEnum,
                directionsService: null,
                directionsRenderer: null,
                umbrellasOpen: false,
                selectedUmbrellaModels: [],
                selectedSingleUmbrella: '',
                selectedSingleUmbrellaTitle: '',
                selectedServices: [],
                filteredUmbrellaModels: [],
                filteredServices: [],
                models: [],
                notAvailable: [],
                dealerItemDropDown: false,
                locationError: false
            },
            watch: {
                map: function() {
                    this.goToOverview();
                },
                dealers: {
                    handler(newVal, oldVal)
                    {
                        this.parseData();
                    }
                },
                addressInput: function() {
                    if (this.addressInput.length > 3) {
                        // Use timeout to wait for user input complete
                        // clearTimeout(this.updateTimeout);
                        // this.updateTimeout = setTimeout(this.setUserGeodata, 1000);
                    }
                },
                selectedServices: {
                    handler(newVal, oldVal) {
                        // This function will be called whenever selectedServices changes
                        this.updateUrl(); // Call a method to update the URL
                    },
                    deep: true, // Watch for changes inside the array (important!)
                },
                selectedUmbrellaModels:  {
                    handler(newVal, oldVal) {
                        this.updateUrl();
                    },
                    deep: true, // Watch for changes inside the array (important!)
                }
            },
            methods: {
                t(key, options) {
                    return FireI18n.t(key, options);
                },
                showIcons() {
                    // Create markers
                    this.markers = this.activeDealersList.map((dealer) => {
                        const latLng = new google.maps.LatLng(
                            dealer.lat,
                            dealer.lng
                        );

                        let individualIcon;
                        let iconWidth = 96;
                        let iconHeight = 96;

                        // [X, P, PHG, RS, SHG,, V]
                        let dealerServices = [0, 0, 0, 0, 0, 0];

                        if (dealer.oc_specialist_dealer == 1) {
                            dealerServices[0] = 1;
                        }

                        if (dealer.oc_premiumretailer == 1) {
                            dealerServices[1] = 1;
                        }

                        if (dealer.oc_premiumcontract == 1) {
                            dealerServices[2] = 1;
                        }

                        if (dealer.oc_repairservice == 1) {
                            dealerServices[3] = 1;
                        }

                        if (dealer.oc_specialisthotelgastronomy == 1) {
                            dealerServices[4] = 1;
                        }
                        if (dealer.oc_fachhaendlerdesigncollection == 1) {
                            dealerServices[5] = 1;
                        }

                        console.log('dealerServices:', dealerServices);
                        // oc_specialist_dealer | oc_premiumretailer | oc_premiumcontract | oc_repairservice | oc_specialisthotelgastronomy
                        switch (dealerServices.join(' ')) {
                            // X
                            case '0 0 0 0 0 0':
                            case '1 0 0 0 0 0':
                                individualIcon = this.icons.store.icon;
                                break;

                            // X_SHG
                            case '1 0 0 0 1 0':
                                individualIcon = this.icons.X_SHG.icon;
                                break;

                            // X_RS
                            case '1 0 0 1 0 0':
                                individualIcon = this.icons.X_RS.icon;
                                break;

                            // X_RS_SHG
                            case '1 0 0 1 1 0':
                                individualIcon = this.icons.X_RS_SHG.icon;
                                break;

                            // X_PHG
                            case '1 0 1 0 0 0':
                            case '1 0 1 0 1 0':
                                individualIcon = this.icons.X_PHG.icon;
                                break;
                            // X_PHG_RS
                            case '1 0 1 1 0 0':
                            case '1 0 1 1 1 0':
                                individualIcon = this.icons.X_PHG_RS.icon;
                                break;

                            // SHG
                            case '0 0 0 0 1 0':
                                individualIcon = this.icons.SHG.icon;
                                break;
                            // RS
                            case '0 0 0 1 0 0':
                                individualIcon = this.icons.RS.icon;
                                break;

                            // RS_SHG
                            case '0 0 0 1 1 0':
                                individualIcon = this.icons.RS_SHG.icon;
                                break;

                            //PHG
                            case '0 0 1 0 0 0':
                            case '0 0 1 0 1 0':
                                individualIcon = this.icons.PHG.icon;
                                break;

                            // PHG_RS
                            case '0 0 1 1 0 0':
                            case '0 0 1 1 1 0':
                                individualIcon = this.icons.PHG_RS.icon;
                                break;

                            // P
                            case '0 1 0 0 0 0':
                            case '1 1 0 0 0 0':
                                individualIcon = this.icons.P.icon;
                                break;

                            // P_SHG
                            case '0 1 0 0 1 0':
                            case '1 1 0 0 1 0':
                                individualIcon = this.icons.P_SHG.icon;
                                break;

                            // P_RS
                            case '0 1 0 1 0 0':
                            case '1 1 0 1 0 0':
                                individualIcon = this.icons.P_RS.icon;
                                break;

                            // P_RS_SHG
                            case '0 1 0 1 1 0':
                            case '1 1 0 1 1 0':
                                individualIcon = this.icons.P_RS_SHG.icon;
                                break;

                            // PHG_P
                            case '0 1 1 0 0 0':
                            case '0 1 1 0 1 0':
                            case '1 1 1 0 0 0':
                            case '1 1 1 0 1 0':
                                individualIcon = this.icons.PHG_P.icon;
                                break;

                            // PHG_P_RS
                            case '0 1 1 1 0 0':
                            case '0 1 1 1 1 0':
                            case '1 1 1 1 0 0':
                            case '1 1 1 1 1 0':
                                individualIcon = this.icons.PHG_P_RS.icon;
                                break;

                            //V cases
                            case '0 0 0 0 0 1':
                                individualIcon = this.icons.V.icon;
                                break;
                            // V_X
                            case '1 0 0 0 0 1':
                                individualIcon = this.icons.V_X.icon;
                                break;

                            // V_X_SHG
                            case '1 0 0 0 1 1':
                                individualIcon = this.icons.V_X_SHG.icon;
                                break;

                            // V_X_RS
                            case '1 0 0 1 0 1':
                                individualIcon = this.icons.V_X_RS.icon;
                                break;

                            // V_X_SHG_RS
                            case '1 0 0 1 1 1':
                                individualIcon = this.icons.V_X_SHG_RS.icon;
                                break;

                            // V_X_PHG
                            case '1 0 1 0 0 1':
                            case '1 0 1 0 1 1':
                                individualIcon = this.icons.V_X_PHG.icon;
                                break;

                            // V_X_RS_PHG
                            case '1 0 1 1 0 1':
                            case '1 0 1 1 1 1':
                                individualIcon = this.icons.V_X_RS_PHG.icon;
                                break;

                            // V_SHG
                            case '0 0 0 0 1 1':
                                individualIcon = this.icons.V_SHG.icon;
                                break;
                            // V_RS
                            case '0 0 0 1 0 1':
                                individualIcon = this.icons.V_RS.icon;
                                break;

                            // V_SHG_RS
                            case '0 0 0 1 1 1':
                                individualIcon = this.icons.V_SHG_RS.icon;
                                break;

                            //V_PHG
                            case '0 0 1 0 0 1':
                            case '0 0 1 0 1 1':
                                individualIcon = this.icons.V_PHG.icon;
                                break;

                            // V_RS_PHG
                            case '0 0 1 1 0 1':
                            case '0 0 1 1 1 1':
                                individualIcon = this.icons.V_RS_PHG.icon;
                                break;

                            // V_P
                            case '0 1 0 0 0 1':
                            case '1 1 0 0 0 1':
                                individualIcon = this.icons.V_P.icon;
                                break;

                            // V_SHG_P
                            case '0 1 0 0 1 1':
                            case '1 1 0 0 1 1':
                                individualIcon = this.icons.V_SHG_P.icon;
                                break;

                            // V_RS_P
                            case '0 1 0 1 0 1':
                            case '1 1 0 1 0 1':
                                individualIcon = this.icons.V_RS_P.icon;
                                break;


                            // V_P_PHG
                            case '0 1 1 0 0 1':
                            case '0 1 1 0 1 1':
                            case '1 1 1 0 0 1':
                            case '1 1 1 0 1 1':
                                individualIcon = this.icons.V_P_PHG.icon;
                                break;

                            // V_RS_P_PHG
                            case '0 1 1 1 0 1':
                            case '0 1 1 1 1 1':
                            case '1 1 1 1 0 1':
                            case '1 1 1 1 1 1':
                                individualIcon = this.icons.V_RS_P_PHG.icon;
                                break;

                            // X
                            default:
                                individualIcon = this.icons.store.icon;
                                break;
                        }

                        return new google.maps.Marker({
                            position: latLng,
                            icon: {
                                url: individualIcon,
                                scaledSize: new google.maps.Size(
                                    iconWidth,
                                    iconHeight
                                )
                            },
                            optimized: true,
                            dealerId: dealer.dealerId,
                        });
                    });

                    for (const i in this.markers) {
                        const marker = this.markers[i];
                        this.activeDealersList[i].marker = marker;

                        const dealerEmail = this.activeDealersList[i].email;
                        let dealerUrl = this.activeDealersList[i].website;
                        if (this.activeDealersList[i].oc_servicecenterwebsite) {
                            dealerUrl = this.activeDealersList[i].oc_servicecenterwebsite;
                        }
                        if (!dealerUrl.includes('http')) {
                            dealerUrl = 'https://' + dealerUrl;
                        }

                        const p = [];
                        p.push(this.activeDealersList[i].street);
                        p.push(`${this.activeDealersList[i].zip} ${this.activeDealersList[i].city}`);
                        //p.push(country);

                        const umbrellas = this.getProvidedUmbrellasByDealer(this.activeDealersList[i]);
                        const links = [];
                        for (const link of umbrellas) {
                            const linkHtml = `<a href='${link.path}' target="_blank">${link.title}</a>`;
                            links.push(linkHtml)
                        }
                        const umbrellaText = links.join('</p><p>');

                        const popUpContent =
                            `<div class="dealerfinder__popup dealerFinderPopup-${i}">`+
                                (this.activeDealersList[i].oc_additionalinfo ? `<h3>${this.activeDealersList[i].oc_additionalinfo}</h3>` : '<h3>${this.activeDealersList[i].title}</h3>')+
                                `<p>${p.join('<br />')}</p>`+
                                (umbrellas.length ? `<h4 onclick="document.querySelector('.dealerFinderPopup-${i} .umbrella-selection').classList.toggle('d-none');")>` + this.t('dealer.umbrella_ondispay') + `<i class="icon-ui-plus"></i></h4><div class="umbrella-selection d-none"><p>${umbrellaText}</p></div>` : '')+
                                (dealerUrl ? `<a href='${dealerUrl}' target='_blank'>` + this.t('dealer.goto_dealer') + `</a>` : '')+
                                (dealerEmail ? `<a class='button' onclick="window.openDealerPopup('${this.activeDealersList[i].email}', '${this.activeDealersList[i].oc_additionalinfo}')">` + this.t('dealer.enquiry') + `</a>` : '')+
                            '</div>';

                        const infoWindow = new google.maps.InfoWindow({
                            content: popUpContent,
                            maxWidth: 350,
                            minWidth: 350,
                            padding: 20,
                        });

                        this.activeDealersList[i].infoWindow = infoWindow;

                        marker.addListener('click', (event) => {
                            this.goToDetail(event.domEvent, this.activeDealersList[i]);
                            infoWindow.open(this.map, marker);
                        });
                    }

                    this.setMarkerCluster();
                },
                ensureOneMarkerVisible() {
                    const bounds = this.map.getBounds();
                    let found = this.markers.some((marker) => {
                        return bounds.contains(marker.getPosition());
                    });
                    if(!found) {
                        this.map.setZoom(this.map.getZoom() - 1);
                    }
                },
                setMarkerCluster() {
                    if(this.markerCluster instanceof MarkerClusterer)
                    {
                        this.markerCluster.clearMarkers();
                    }

                    this.markerCluster = new MarkerClusterer(
                        this.map,
                        this.markers,
                        {
                            styles: [ this.elementIsVisible(this.$refs.mobilecontrol) ? this.icons.clusterMobile : this.icons.cluster ]
                        }
                    );
                },
                showMarkerCluster() {
                    this.markerCluster.setMap(this.map);
                },
                hideMarkerCluster() {
                    this.markerCluster.setMap(null);
                },
                hideOpenMapPopups() {
                    [...document.querySelectorAll('.dealerfinder__popup')].map((el) => {
                        const parentBox = el.closest('.gm-style-iw.gm-style-iw-c');
                        const closeButton = parentBox.querySelector('button.gm-ui-hover-effect');
                        closeButton.click();
                    });
                },
                hideOpenMapNavigationPopups() {
                    [...document.querySelectorAll('.dealerfinder__popup-navigation')].map((el) => {
                        const parentBox = el.closest('.gm-style-iw.gm-style-iw-c');
                        const closeButton = parentBox.querySelector('button.gm-ui-hover-effect');
                        closeButton.click();
                    });
                },
                async initMap() {
                    this.directionsService = new google.maps.DirectionsService();
                    this.directionsRenderer = new google.maps.DirectionsRenderer({
                        suppressInfoWindows: true,
                        suppressMarkers: true
                    });

                    this.map = new google.maps.Map(
                      this.$refs.map,
                        {
                            zoom: this.defaultLocation.zoom,
                            center: { lat: this.defaultLocation.lat, lng: this.defaultLocation.lng },
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                            styles: this.mapStyle,
                            disableDefaultUI: true,
                        }
                    );

                    // loads custom zoom controls
                    const zoomDiv = document.createElement('div');
                    zoomDiv.index = 0;
                    this.zoomControl(zoomDiv, this.map);
                    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomDiv);
                    return true;
                },
                setMap(lng, lat, zoom) {
                    if (!lng || !lat) return;
                    const targetLatLng = new google.maps.LatLng(lng, lat);
                    const targetZoom = zoom;
                    this.map.setCenter(targetLatLng);
                    this.map.setZoom(targetZoom);
                    this.showIcons();
                },
                deg2rad(deg) {
                    return deg * (Math.PI / 180);
                },
                getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
                    var R = 6371; // Radius of the earth in km
                    var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
                    var dLon = this.deg2rad(lon2 - lon1);
                    var a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);
                    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    var d = R * c; // Distance in km
                    return d;
                },
                elementIsVisible(el) {
                    //return 'none' !== window.getComputedStyle(el).display;
                },
                resizeMap() {
                    if (!this.elementIsVisible(this.$refs.mobilecontrol)) {
                        const mapBound = this.$refs.map.getBoundingClientRect();
                        this.$refs.mapwrap.style.width = `${window.innerWidth - mapBound.left}px`;
                        return;
                    }
                    this.$refs.mapwrap.style.width = null;
                },
                scrollTo(parentWindow, positionTop, smooth) {
                    this.$nextTick(() => {
                        parentWindow.scrollTo({
                            top: positionTop,
                            left: 0,
                            behavior: smooth ? 'smooth' : 'instant'
                        });
                    });
                },
                zoomControl(div, map) {
                    // Get the control DIV. We'll attach our control UI to this DIV.
                    const parentControlDiv = div;
                    parentControlDiv.className = 'zoom-controls';

                    const zoominIcon = document.createElement('i');
                    zoominIcon.classList.add('icon-ui-plus');

                    const zoomin = document.createElement('div');
                    zoomin.title = 'Click to zoom in';
                    zoomin.className = 'zoom-control';
                    zoomin.appendChild(zoominIcon);
                    zoomin.addEventListener('click', function() {
                        const currentZoomLevel = map.getZoom();
                        if (currentZoomLevel < 21) map.setZoom(currentZoomLevel + 1);
                    });
                    parentControlDiv.appendChild(zoomin);

                    const zoomoutIcon = document.createElement('i');
                    zoomoutIcon.classList.add('icon-ui-minus');

                    const zoomout = document.createElement('div');
                    zoomout.title = 'Click to zoom out';
                    zoomout.className = 'zoom-control';
                    zoomout.appendChild(zoomoutIcon);
                    zoomout.addEventListener('click', function() {
                        var currentZoomLevel = map.getZoom();
                        if(currentZoomLevel > 0) map.setZoom(currentZoomLevel - 1);
                    });

                    parentControlDiv.appendChild(zoomout);
                },
                formatDistance(distance) {
                    if (!distance) return null;
                    if (distance > 1000) {
                        return (distance / 1000).toFixed(1) + 'km';
                    }
                    return distance.toFixed(0) + 'm';
                },
                handleOnScroll() {
                    // using getElement() to make sure element is around
                    this.getElement('.dealerfinder__map')
                        .then(() => {
                            if (!this.elementIsVisible(this.$refs.mobilecontrol)) {
                                // (not using this.$refs.look because getBoundingClientRect is not working here)
                                const header = document.querySelector('#header');
                                const headerBoundaries = header.getBoundingClientRect();
                                const el = document.querySelector(`.${this.element}`);
                                const map = el; //el.querySelector('.dealerfinder__map');
                                const mapBoundaries = map.getBoundingClientRect();
                                const mapBottom = map.offsetTop + mapBoundaries.height;
                                const viewportBottom = window.scrollY + window.innerHeight;

                                if ((0 < mapBoundaries.y)) {
                                    el.classList.add('align-top');

                                } else {
                                    el.classList.remove('align-top');

                                }

                                if (0 >= mapBoundaries.y - headerBoundaries.height && viewportBottom - headerBoundaries.height <= mapBottom) {
                                    el.classList.add('align-fixed');

                                } else {
                                    el.classList.remove('align-fixed');

                                }

                                if (viewportBottom - headerBoundaries.height > mapBottom) {
                                    el.classList.add('align-bottom');

                                } else {
                                    el.classList.remove('align-bottom');

                                }
                            }
                        });
                },
                setHistory(search_value, services, umbrellas) {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    if (search_value) {
                        urlParams.set('location', search_value);
                    } else {
                        urlParams.delete('location');
                    }
                    if (services) {
                        urlParams.set('services', services);
                    } else {
                        urlParams.delete('services');
                    }
                    if (umbrellas) {
                        urlParams.set('umbrellas', umbrellas);
                    } else {
                        urlParams.delete('umbrellas');
                    }


                    let url = location.protocol + '//' + location.host + location.pathname;
                    const params = urlParams.toString()
                    if (params !== '') {
                        url = `${url}?${urlParams.toString()}`
                    }
                    window.history.pushState(
                        {
                            id: 'dealerfinder'
                        },
                        '',
                        `${url}`
                    );
                    this.listByUmbrellaModels();
                    this.filterByServices();
                },
                getHistory() {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    return [urlParams.get('location'), urlParams.get('services'), urlParams.get('umbrellas')];
                },
                setAddressInput() {
                    let val = String(document.querySelector('#finderInput').value);
                    const value = val.trim();
                    this.addressInput = value;

                    if ('' != value)
                    {
                        this.isLocated = true;

                        this.setUserGeodata()
                            .then((results) => {
                                const lat = results[0].geometry.location.lat();
                                const lng = results[0].geometry.location.lng();
                                this.userLocation = {lat, lng};
                                this.mapState = this.mapStates.OVERVIEW;
                                this.locationError = false;
                                this.parseData()
                                    .then(() => {
                                        this.updateUrl()
                                        this.goToResult();
                                    });
                            })
                            .catch((reason) =>
                            {
                                console.error(reason);
                                this.mapState = this.mapStates.OVERVIEW;
                                this.locationError = true;
                                this.activeDealersList = [];
                                this.activeDealersMap= [];
                            })
                    } else {
                        this.updateUrl()
                    }
                },
                nl2br(str, is_xhtml) {
                    const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>';
                    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
                },
                getCountryNameByCode(search) {
                    const code = search.toUpperCase();
                    const find = this.countries.find(country => country.countryCode === code);
                    return find ? find.name : search;
                },
                async setUserGeodata() {
                    return new Promise((resolve, reject) => {
                        const geocoder = new google.maps.Geocoder();
                        let country = 'CH';
                        let location = null;

                        if (this.userCountry) {
                            country = this.userCountry.short_name;
                        }

                        if (this.userLocation) {

                            location = this.userLocation;
                        }
                        if (/^\d+$/.test( this.addressInput))
                        {
                            geocoder.geocode({
                                address: this.addressInput ? this.addressInput : null,
                                region: country,
                                componentRestrictions: {
                                    country: country
                                },

                            }, (results, status) => {
                                if (status === "OK") return resolve(results);
                                reject(status);
                            });
                        } else {
                            geocoder.geocode({
                                address: this.addressInput ? this.addressInput : null,
                                region: country,
                            }, (results, status) => {
                                if(status === "OK") return resolve(results);
                                reject(status);
                            });
                        }
                    });
                },
                setUserCountry() {
                    return new Promise((resolve, reject) => {
                        const geocoder = new google.maps.Geocoder();
                        // const center = this.map.getCenter();
                        const center = this.userLocation;

                        // load user geolocation data and look for country
                        geocoder.geocode({
                            location: center,
                        }, (results, status) => {
                            if (status === "OK") {
                                let country = null;
                                if (results) {
                                    for(const item of results) {
                                        if (item.types.indexOf('country') > -1) {
                                            country = item.address_components[0];
                                            break;
                                        }
                                    }
                                }

                                if (!country) {
                                    console.error('user country not found');
                                    return reject(false);
                                }
                                this.userCountry = country;
                                resolve(true);
                            }
                        });
                    });
                },
                getElement(selector, i) {
                    i = i ? i : 0;
                    return new Promise((resolve, reject) => {
                        if (i > 10) return reject(`To many tries - Could not fetch ${selector}`);
                        const el = this.$refs.dealerfinder.querySelector(selector);
                        if (el) return resolve(el);
                        setTimeout(() => {
                            this.getElement(selector, i + 1).then(resolve).catch(reject);
                        }, 100);
                    });
                },
                async parseData() {
                    //removed  check on location-service mostly to slow on load, data is more importan then accurate location
                    const lat = this.userLocation ? this.userLocation.lat : this.defaultLocation.lat;
                    const lng = this.userLocation ? this.userLocation.lng : this.defaultLocation.lng;
                    let zoom = this.defaultLocation.zoom;
                    if (this.mapState == this.mapStates.RESULT) zoom = 8;
                    this.setMap(lat, lng, zoom);

                    this.activeDealersList = [];
                    this.activeDealersMap = [];

                    //short is the normal 30km view distance long is only used if there are less than 10 in 30km
                    this.distanceList = {};

                    for (const dealer of this.dealers) {
                        this.activeDealersList.push(dealer);
                        this.activeDealersMap.push(dealer);

                    }


                    //this.applyModelTypeFilter();
                    //this.updateMapPlacement();

                    return true;
                },
                updateMapPlacement() {
                    this.scrollTo(window, 0, false);
                    window.dispatchEvent(new Event('scroll'));
                },
                setUserLocation() {
                    navigator.geolocation.getCurrentPosition(
                        (geoPosition) => {
                            // success
                            this.userLocation = {
                                lat: geoPosition.coords.latitude,
                                lng: geoPosition.coords.longitude
                            }

                            this.loadCountries();
                            this.initMap()
                                .then(() => {
                                    window.addEventListener('resize', this.resizeMap);
                                    this.$nextTick(async () => {
                                        this.resizeMap();
                                    });
                                });
                        },

                        // error
                        (error) => {
                            console.warn(`ERROR(${error.code}): ${error.message}`);

                            this.userLocation = {
                                lat: this.defaultLocation.lat,
                                lng: this.defaultLocation.lng
                            };

                            //since the default lat/lng map zu zurich switzerland we set the country to switzerland
                            this.userCountry = {"long_name":"Schweiz","short_name":"CH","types":["country","political"]};
                        }
                    );
                },
                updateUrl() {
                    const url = new URL(window.location.href);
                    url.searchParams.delete('services');
                    const params = this.selectedServices.map(encodeURIComponent).join('-');
                    if (params !== '') {
                        url.searchParams.append('services', params);
                            this.selectedServices.forEach((item) => {
                                let checkbox = document.getElementById(item)
                                if (checkbox) {
                                    checkbox.checked = true
                                }
                            })

                    } else {
                        url.searchParams.delete('services');
                    }
                    url.searchParams.delete('umbrellas');
                    const umbrellaparams = this.selectedUmbrellaModels.map(encodeURIComponent).join('-');
                    if (umbrellaparams !== '') {
                        url.searchParams.append('umbrellas', umbrellaparams);
                    }
                    this.setHistory(this.addressInput, params, umbrellaparams)
                },

                async makeRequest(body) {
                    return fetch(graphqlApi, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-Token': yii.getCsrfToken()
                            },
                            body: JSON.stringify(body)
                        })
                        .then(res => {
                            if(!res) {
                                throw(this.t('notification.error_has_occurred'));
                            }
                            return res;
                        })
                        .then(res => res.json())
                        .catch(console.error);
                },
                loadCountries() {
                    const limit = 250;
                    const body = {
                        query: gql`
                            query getCountries($limit: Int!) {
                                countries(limit: $limit) {
                                    results {
                                        countryId
                                        countryCode
                                        name
                                    }
                                }
                            }
                        `,
                        variables: {
                            limit,
                        },
                    };

                    this.makeRequest(body).then((res) => {
                        this.countries = [...[], ...res.data.countries.results];
                    })
                    .catch(console.error);
                },
                href(e) {
                    e.preventDefault();
                    window.open(e.target.href);

                },
                openDealerPopup(dealerMail, dealerName)
                {
                    window.openDealerPopup(dealerMail, dealerName);
                },
                loadDataDetail(dealer) {
                    this.dealer = null;

                    const dealerId = dealer.dealerId;

                    const body = {
                        query: gql`
                            query getDealer($dealerId: ID!)
                            {
                                dealer(dealerId: $dealerId)
                                {
                                    dealerId
                                    title
                                    subtitle
                                    teaser(format:HTML)
                                    description(format:HTML)
                                    street
                                    zip
                                    city
                                    country
                                    phone
                                    fax
                                    email
                                    website
                                    medias {
                                        id
                                        targetClass
                                        targetId
                                        targetAttr
                                        path
                                    }
                                }
                            }
                        `,
                        variables: {
                            dealerId
                        },
                    };

                    return this.makeRequest(body)
                        .then(res => {
                            if (res.data && res.data.dealer) {
                                this.dealer = {
                                    ... dealer,
                                    ... res.data.dealer,
                                    ... { complete: true }
                                };
                            }
                            return this.dealer;
                        })
                        .catch(console.error);
                },
                loadData() {
                    this.dealers = [];

                    this.enableLoading();
                    const offset = 0;
                    const lat = this.defaultLocation.lat;
                    const lng = this.defaultLocation.lng;
                    //const sortBy = "DEALER_DISTANCE_ASC";
                    const body = {
                        query: gql`
                            query getDealersByDistance($offset: Int, $lat: Float!, $lng: Float!)
                            {
                                dealersByDistance(offset: $offset, lat: $lat, lng: $lng)
                                {
                                    results {
                                        dealerId
                                        title
                                        street
                                        zip
                                        city
                                        country
                                        phone
                                        email
                                        distance
                                        lng
                                        lat
                                        website
                                        oc_servicecenterwebsite
                                        oc_onlineshopwebsite
                                        oc_premiumcontractbusiness
                                        oc_premiumcontract
                                        oc_premiumretailer
                                        oc_repairservice
                                        oc_specialisthotelgastronomy
                                        oc_productmodelno
                                        oc_specialist_dealer
                                        oc_additionalinfo
                                        oc_fachhaendlerdesigncollection
                                    }
                                }
                            }
                        `,
                        variables: {
                            offset,
                            lat,
                            lng,
                            //sortBy,
                        },
                    };

                    return this.makeRequest(body).then(res => {
                            if (res.data && res.data.dealersByDistance) {
                                this.dealers = res.data.dealersByDistance.results;
                            }
                            this.disableLoading();
                            return this.dealers;
                        })
                        .catch((err) => {
                            console.error(err);
                            this.disableLoading();
                        });
                },
                async goToOverview(event) {
                    if (event) event.preventDefault();
                    if (!this.userCountry) await this.setUserCountry();
                    const lat = this.userLocation.lat;
                    const lng = this.userLocation.lng;
                    const zoom = 12;
                    this.setMap(lat, lng, zoom);
                    this.updateMapPlacement();
                    return true;
                },
                async goToResult(event) {
                    if (event) event.preventDefault();
                    this.mapState = this.mapStates.OVERVIEW;
                    //this.parseData();
                    const zoom = 12;
                    this.map.setZoom(zoom);
                    this.updateMapPlacement();
                    this.ensureOneMarkerVisible();
                    return true;
                },
                async goToDetail(event, dealer) {
                    event.preventDefault();
                    event.stopPropagation();

                    const lat = dealer.lat;
                    const lng = dealer.lng;
                    const zoom = 12;
                    this.setMap(lat, lng, zoom);
                    const center = new google.maps.LatLng(lat, lng);
                    this.map.panTo(center);
                    this.map.setZoom(zoom);
                    /*this.updateMapPlacement();*/
                    this.hideOpenMapPopups();

                    return true;
                },
                enableLoading() {
                    this.isLoading = true;
                },
                disableLoading() {
                    this.isLoading = false;
                },
                toggleUmbrellaModels() {
                    this.umbrellasOpen = !this.umbrellasOpen;
                },
                closeUmbrellaModels() {
                    this.umbrellasOpen = false;
                },
                checkService(event) {
                    // get checked service
                    let checkedServices = document.querySelectorAll('.dealerfinder__service input[type=checkbox]:checked');
                    this.selectedServices = [];
                    for(let i = 0; i < checkedServices.length; i++)
                    {
                        this.selectedServices.push(checkedServices[i].id);
                    }
                    this.filterByServices();
                },
                listSelectedUmbrellas() {
                    let selectedUmbrellas = '';
                    document.querySelectorAll('.umbrella-selection ul li.active').forEach(function (item) {
                        let title = (item.textContent).trim() + ', ';
                        selectedUmbrellas += title;
                    });
                    if (selectedUmbrellas != '') {
                        selectedUmbrellas = selectedUmbrellas.slice(0, -2);
                    }
                    this.selectedSingleUmbrellaTitle = selectedUmbrellas;
                },
                listByUmbrellaModels() {
                    this.isLoading = true;
                    console.log('listByUmbrellaModels');
                    // filter dealers list by umbrella models
                    if(this.selectedServices.length > 0)
                    {
                        this.filterByServices();
                    }
                    else if (this.selectedUmbrellaModels.length > 0) {
                        this.filterByUmbrellaModels(this.activeDealersMap);
                    } else {
                        this.activeDealersList = this.activeDealersMap;
                    }

                    // if selected, filter by service
                    if (this.selectedServices.length > 0) {
                        const filteredDealersByService = [];

                        for (const dealer of this.activeDealersList) {
                            if (
                                (dealer.oc_specialist_dealer == 1 && this.selectedServices.includes('retailer')) ||
                                (dealer.oc_specialisthotelgastronomy == 1 && this.selectedServices.includes('expert')) ||
                                (dealer.oc_repairservice == 1 && this.selectedServices.includes('repair'))
                            ) {
                                filteredDealersByService.push(dealer);
                            }
                        }

                        this.activeDealersList = filteredDealersByService;
                    }

                    this.isLoading = false;
                },
                filterByServices() {
                    this.isLoading = true;

                    // filter dealers by selected services
                    if (this.selectedServices.length > 0) {
                        const filteredDealersByService = [];
                        for (const dealer of this.activeDealersMap) {
                            if (
                                this.selectedServices.includes('retailer') &&
                                (dealer.oc_specialist_dealer == 1 || dealer.oc_premiumretailer == 1)
                            ) {
                                filteredDealersByService.push(dealer);
                            }
                            else if (
                                this.selectedServices.includes('expert') &&
                                (dealer.oc_premiumcontract == 1 || dealer.oc_premiumcontractbusiness == 1|| dealer.oc_specialisthotelgastronomy == 1)

                            ) {
                                filteredDealersByService.push(dealer);
                            } else if (
                                this.selectedServices.includes('repair') &&
                                dealer.oc_repairservice == 1
                            ) {
                                filteredDealersByService.push(dealer);
                            } else if (
                                this.selectedServices.includes('expertpro') &&
                                (dealer.oc_premiumcontract == 1 || dealer.oc_premiumcontractbusiness == 1)
                            ) {
                                filteredDealersByService.push(dealer);
                            } else if (
                                this.selectedServices.includes('retailerpro') &&
                                (dealer.oc_premiumretailer == 1)
                            ) {
                                filteredDealersByService.push(dealer);
                            } else if (
                                this.selectedServices.includes('vita') &&
                                (dealer.oc_fachhaendlerdesigncollection == 1)
                            ) {
                                 filteredDealersByService.push(dealer);
                            }
                        }

                        // if selected, filter by selected umbrella models
                        if (this.selectedUmbrellaModels.length > 0) {
                            this.filterByUmbrellaModels(filteredDealersByService);
                        } else {
                            this.activeDealersList = filteredDealersByService;
                            this.showIcons();
                        }

                    } else if (this.selectedUmbrellaModels.length > 0) {
                        // if selected, filter by selected umbrella models
                        this.filterByUmbrellaModels(this.activeDealersMap);
                    } else {
                        this.activeDealersList = this.activeDealersMap;
                        this.showIcons();
                    }

                    this.isLoading = false;
                },
                filterByUmbrellaModels(list) {
                    this.isLoading = true;

                    const filteredDealersByUmbrellaModel = [];

                    for (const dealer of list) {
                        if (dealer.oc_productmodelno) {
                            const providedModels = dealer.oc_productmodelno.split(',');
                            let temporaryDealersList = [];
                            for (const singleModel of providedModels){
                                if (this.selectedUmbrellaModels.includes(singleModel)) {
                                temporaryDealersList.push(dealer);
                                }
                            }
                            if (temporaryDealersList.length == this.selectedUmbrellaModels.length){
                                //has all selected umbrellas
                                filteredDealersByUmbrellaModel.push(dealer);
                            }
                        }
                    }

                    this.activeDealersList = filteredDealersByUmbrellaModel;
                    this.showIcons();
                    this.isLoading = false;
                },
                getProvidedUmbrellasByDealer(dealer) {
                    const models = [];
                    if (dealer.oc_productmodelno != null) {
                        for (const [i, model] of dealer.oc_productmodelno.split(',').entries()) {
                            let modeltem = this.models.find(item => {
                                return model == Number.parseInt(item.key)
                            });
                            if(modeltem) {
                                models.push(modeltem);
                            }
                        }
                        models.sort((a, b) => (a.sort > b.sort) ? 1 : -1);
                    }
                    return models;
                },
                umbrellaDropDownToggle(e) {
                    e.preventDefault();
                    this.dealerItemDropDown = !this.dealerItemDropDown;

                    if (e.target.localName === 'button') {
                        e.target.nextElementSibling.classList.toggle('d-none');
                        e.target.firstElementChild.classList.toggle('rotate180');
                    } else if (e.target.localName === 'span') {
                        e.target.parentNode.nextElementSibling.classList.toggle('d-none');
                        e.target.classList.toggle('rotate180');
                    }
                },
                infoWindow(dealer) {
                    this.hideOpenMapPopups();
                    dealer.infoWindow.open(this.map, dealer.marker);
                },
                checkIsMobile() {
                    //let mql = window.matchMedia('(max-width: 767px)');
                    let mql = window.matchMedia('(max-width: 991px)');
                    if(mql.matches) {
                        this.isMobile = true;
                    } else  {
                        this.isMobile = false;
                    }

                    let smartphone = window.matchMedia('(max-width: 575px)');
                    if(smartphone.matches) {
                        this.isSmartphone = true;
                    } else  {
                        this.isSmartphone = false;
                    }
                },
            },
            beforeMount() {
                //this.setActiveList();
            },
            mounted() {
                this.checkIsMobile();

                // mobile layout
                if (this.isSmartphone || this.isMobile) {
                    // replace search button on mobile screens (isSmartphone || isMobile)
                    const searchButton = document.getElementById('search-button');
                    const newSearchButtonLocation = document.getElementById('search-filter');
                    newSearchButtonLocation.after(searchButton);

                    // hide footer
                    document.getElementById('footer').hidden = true;
                } else {
                    this.mobileView = undefined;
                }

                this.element = this.$el.dataset.id;
                let mArray = [];
                let data = JSON.parse(this.$el.dataset.models);
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const umbrellaKey = urlParams.get('umbrella')
                const services = urlParams.get('services');

                for (let key in data){
                    let title = data[key].title;
                    let path = data[key].path;
                    let sort = data[key].sort;
                    if (key == umbrellaKey) {
                        this.selectedSingleUmbrellaTitle = title
                        this.selectedSingleUmbrella = key
                    }
                    const item = { key, title, path, sort };
                    mArray.push(item);
                }

                mArray.sort((a, b) => (a.sort > b.sort) ? 1 : -1);

                this.models = mArray;
                this.loadCountries();
                this.initMap()
                    .then(() => {
                        window.addEventListener('resize', this.resizeMap);
                        this.$nextTick(async () => {
                            this.resizeMap();
                        });
                    });
                this.loadData()
                    .then(() => {
                        if (window.location.search) {
                            this.goToOverview();
                            const location = this.getHistory()[0];
                            const services = this.getHistory()[1];
                            const umbrellas = this.getHistory()[2];

                            if (services) {
                                this.selectedServices = services.split('-');
                                this.selectedServices.forEach((service) => {
                                    const checkbox = document.getElementById(service);
                                    checkbox.checked = true;
                                })
                            }
                            if(umbrellas){
                                this.selectedUmbrellaModels = umbrellas.split('-')
                                this.listSelectedUmbrellas();
                                this.listByUmbrellaModels();
                            }
                            this.getElement('#finderInput')
                                .then((el) => {
                                    el.value = location;
                                    this.setAddressInput();
                                });
                        } else {
                            //only use user Location if no input
                            this.setUserLocation();
                        }

                        this.getElement('.preloader')
                            .then((el) => {
                                el.classList.remove('d-none');
                            });

                        this.isReady = true;
                        this.goToOverview();
                    });

                window.addEventListener('scroll', this.handleOnScroll);
            },
            created() {
                window.addEventListener("resize", this.checkIsMobile);
            },
            destroyed () {
                window.removeEventListener("resize", this.checkIsMobile);
            },
        });
    }
}

document.addEventListener("DOMContentLoaded", initDealerfinder);
window.addEventListener("Pageeditor:insert", initDealerfinder);
window.addEventListener("Pageeditor:change", initDealerfinder);
window.addEventListener("Pageeditor:move", initDealerfinder);